import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext(null);
const LANGUAGE_STORAGE_KEY = 'sifrifana_language';
const LANGUAGE_DEFAULT_VERSION_KEY = 'sifrifana_language_default_version';
const LANGUAGE_DEFAULT_VERSION = 'geo-default-2026-05-22';
const DEFAULT_LANGUAGE = 'ka';

const translations = {
  en: {
    'common.home': 'HOME',
    'common.product': 'Product',
    'common.products': 'products',
    'common.search': 'Search...',
    'common.searchProducts': 'Search products',
    'common.close': 'Close',
    'common.closeFilters': 'Close filters',
    'common.noProductsAvailable': 'No products available',
    'common.noSimilarProducts': 'No similar products found',
    'common.similarItem': 'Similar item',
    'common.addToCart': 'Add to cart',
    'common.addToWishlist': 'Add to wishlist',
    'common.removeFromWishlist': 'Remove from wishlist',
    'common.buyNow': 'Buy now',
    'common.subtotal': 'Subtotal',
    'common.shipping': 'Shipping',
    'common.free': 'FREE',
    'common.total': 'Total',
    'common.or': 'or',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.saveChanges': 'Save Changes',
    'common.saving': 'Saving...',
    'common.done': 'DONE',
    'common.change': 'CHANGE',
    'common.notSet': 'Not set',
    'common.delete': 'Delete',
    'category.watches': 'WATCHES',
    'category.eyewear': 'EYEWEAR',
    'category.eyeglasses': 'EYEGLASSES',
    'category.perfume': 'PERFUME',
    'category.knives': 'KNIVES',
    'category.presents': 'PRESENTS',
    'category.allProducts': 'All Products',
    'header.cart': 'Cart',
    'header.wishlist': 'Wishlist',
    'header.account': 'Account',
    'hero.title': 'Gifts that make people happy.',
    'hero.subtitle': 'Join Sifrifana and discover gifts that bring happiness.',
    'home.limitedOffers': 'LIMITED OFFERS',
    'home.offer.watchEyebrow': 'LIMITED WATCH DEAL',
    'home.offer.watchTitle': '-15%\nON ALL\nWATCHES',
    'home.offer.saleEyebrow': 'SEASONAL SALE',
    'home.offer.saleTitle': 'CHRISTMAS\nSALE\n-20%',
    'home.offer.giftTitle': 'FREE GIFT',
    'home.offer.giftDescription': 'with every purchase\nover 100₾',
    'home.testimonialsTitle': 'WHAT PEOPLE SAY ABOUT US',
    'home.testimonialQuote': '"I ordered a watch during their sale and it arrived fast and looks even better than in photos. The packaging felt premium too. Definitely shopping here again!"',
    'home.whyTitle': 'WHY SIFRIFANA?',
    'home.why.serviceTitle': 'EXCEPTIONAL SERVICE',
    'home.why.serviceText': 'Customer Oriented Team',
    'home.why.deliveryTitle': 'DELIVERY IN ANY REGION',
    'home.why.deliveryText': 'We offer delivery throughout Georgia',
    'home.why.safetyTitle': 'SAFETY',
    'home.why.safetyText': 'Your payments are always safe with us',
    'catalog.featured': 'Featured',
    'catalog.bestSelling': 'Best Selling',
    'catalog.newArrivals': 'New Arrivals',
    'catalog.priceLowHigh': 'Price: Low to High',
    'catalog.priceHighLow': 'Price: High to Low',
    'catalog.saleHighLow': 'Sale: High to Low',
    'catalog.man': 'Man',
    'catalog.woman': 'Woman',
    'catalog.unisex': 'Unisex',
    'catalog.filters': 'Filters',
    'catalog.sortBy': 'SORT BY',
    'catalog.sex': 'SEX',
    'catalog.brands': 'BRANDS',
    'catalog.price': 'PRICE',
    'catalog.colors': 'COLORS',
    'catalog.prescription': 'PRESCRIPTION',
    'catalog.materials': 'MATERIALS',
    'catalog.giftType': 'Gift type',
    'catalog.presentType.knife': 'Knife',
    'catalog.presentType.lighter': 'Lighter',
    'catalog.presentType.binoculars': 'Binoculars',
    'catalog.presentType.jewelry': 'Jewelry',
    'catalog.clearAll': 'Clear all',
    'catalog.noProducts': 'No products found',
    'catalog.noProductsHint': 'Try adjusting your filters or search query.',
    'catalog.resetFilters': 'Reset Filters',
    'product.notFound': 'Product not found.',
    'product.previousImage': 'Previous product image',
    'product.nextImage': 'Next product image',
    'product.zoomImage': 'Zoom product image',
    'product.closeZoom': 'Close image zoom',
    'product.view': 'view',
    'product.color': 'Color',
    'product.prescription': 'Prescription',
    'product.specialCode': 'Product code',
    'product.quantity': 'Quantity',
    'product.inStock': 'IN STOCK',
    'product.outOfStock': 'OUT OF STOCK',
    'product.buyItNow': 'Buy It Now',
    'product.installment': 'Installment',
    'checkout.freeShipping': 'Free shipping everywhere',
    'checkout.courierServiceFee': '+5 GEL / +5 ლარი საკურიერო მომსახურება',
    'checkout.paymentOptions': 'Payment options',
    'checkout.payWithCourier': 'Pay with courier',
    'checkout.payByCard': 'Pay by card',
    'checkout.boxTitle': 'Choose gift box',
    'checkout.boxSubtitle': 'Packaging',
    'checkout.boxBasic': 'Free basic box',
    'checkout.boxGood': 'Good box',
    'checkout.boxBrand': 'Brand Sifrifana box',
    'checkout.boxSummary': 'Box',
    'checkout.included': 'Included',
    'checkout.contactNotice': 'Sifrifana shop will contact you and confirm the order details.',
    'checkout.cardRedirectNote': 'You will enter card details on a secure bank payment page.',
    'checkout.phoneNumber': 'Phone number',
    'checkout.customerName': 'First and last name',
    'checkout.deliveryRegion': 'Region',
    'checkout.deliveryRegionPlaceholder': 'Choose delivery area',
    'checkout.deliveryCity': 'City',
    'checkout.deliveryCityPlaceholder': 'Type delivery city',
    'checkout.address': 'Delivery address',
    'checkout.addressPlaceholder': 'Exact delivery address',
    'checkout.requiredFields': 'Please enter phone number, first and last name, region, city if needed, and delivery address.',
    'checkout.invalidPhone': 'Phone number must be 9 digits and start with a valid Georgian mobile prefix.',
    'checkout.termsAgree': 'I agree to the',
    'checkout.termsLink': 'Terms and Conditions',
    'checkout.termsRequired': 'Please confirm that you agree to the terms and conditions.',
    'checkout.personalId': 'Personal ID',
    'checkout.personalIdPlaceholder': 'Enter personal ID',
    'checkout.knifeVerificationTitle': 'Knife purchase verification',
    'checkout.knifeGuidelinesAgreement': 'I confirm I am 21+ and agree to all Georgian guidelines for buying this knife.',
    'checkout.knifeVerificationRequired': 'Personal ID and 21+ Georgian guideline confirmation are required for knife orders.',
    'checkout.cardRequired': 'Please enter card number, expiry date, and security code.',
    'checkout.failed': 'Could not submit the order. Please try again.',
    'checkout.checking': 'Checking payment status...',
    'checkout.processing': 'Payment is still processing...',
    'checkout.order': 'ORDER',
    'checkout.ordering': 'ORDERING...',
    'checkout.successStrong': 'Thank you, your order has been received and the item has been reserved.',
    'checkout.successText': 'The Sifrifana shop will contact you and provide details about payment and delivery.',
    'checkout.workingHours': 'Working hours: Every day, 10:00-19:00',
    'checkout.followFacebook': 'Like our official Facebook page and receive exclusive surprises all year round!',
    'checkout.followFacebookPrefix': 'Like our official',
    'checkout.followFacebookSuffix': 'page and receive exclusive surprises all year round!',
    'checkout.allProductsTitle': 'All products',
    'product.aboutBrand': 'ABOUT BRAND',
    'product.aboutFallback': 'This collection brings together craftsmanship, comfort, and expressive design for everyday wear.',
    'product.aboutWithBrand': '{description} {brand} is designed to balance individuality, comfort, and premium daily wear.',
    'product.characteristics': 'CHARACTERISTICS',
    'product.dimensions': 'DIMENSIONS',
    'product.brand': 'Brand',
    'product.style': 'Style',
    'product.styleVintage': 'Vintage',
    'product.styleClassic': 'Classic',
    'product.use': 'Use',
    'product.useSun': 'Sun',
    'product.useVision': 'Vision',
    'product.useDaily': 'Daily',
    'product.material': 'Material',
    'product.materialWood': 'Wood',
    'product.materialSteel': 'Stainless Steel',
    'product.frameWidth': 'Frame Width',
    'product.frameHeight': 'Frame Height',
    'product.bridge': 'Bridge',
    'product.ears': 'Ears',
    'product.faqPurchaseTitle': 'How to Purchase the Product?',
    'product.faqPurchaseText': 'Choose the available options and quantity, add the item to your cart, and continue through checkout to complete your order.',
    'product.faqDeliveryTitle': 'How is the Product Delivered?',
    'product.faqDeliveryText': 'Orders are prepared within 1-2 business days and delivered by local courier service to the address you provide at checkout.',
    'product.similarItems': 'SIMILAR ITEMS',
    'cart.shoppingCart': 'Shopping Cart',
    'cart.empty': 'Your cart is empty',
    'cart.orderSummary': 'Order Summary',
    'cart.checkout': 'Proceed to Checkout',
    'cart.remove': 'Remove',
    'cart.myCart': 'My Cart',
    'cart.qty': 'Qty',
    'account.myAccount': 'My Account',
    'account.orders': 'Orders',
    'account.myOrders': 'My orders',
    'account.wishlist': 'Wishlist',
    'account.paymentMethods': 'Payment methods',
    'account.deliveryAddresses': 'Delivery addresses',
    'account.settings': 'Settings',
    'account.adminDashboard': 'Admin Dashboard',
    'account.manageProducts': 'Manage Products',
    'account.users': 'Users',
    'account.signOut': 'Sign Out',
    'account.signIn': 'Sign In',
    'account.signUp': 'Sign Up',
    'account.logout': 'Log out',
    'account.greeting': 'Hi, {name}',
    'orders.title': 'MY ORDERS ({count})',
    'orders.emptyTitle': 'No orders yet',
    'orders.emptyText': 'Your account dashboard is ready. Once you place an order it will appear here.',
    'orders.oneItem': '1 item',
    'orders.moreOne': 'and 1 more item',
    'orders.moreMany': 'and {count} more items',
    'orders.track': 'Track Order',
    'orders.cancel': 'Cancel Order',
    'orders.trackingSoon': 'Tracking details for "{title}" will be available soon.',
    'orders.status.ordered': 'Ordered',
    'orders.status.processing': 'Processing',
    'orders.status.shipped': 'Shipped',
    'orders.status.delivered': 'Delivered',
    'orders.status.cancelled': 'Cancelled',
    'wishlist.emptyTitle': 'Wishlist is empty',
    'wishlist.emptyText': 'Tap the heart icon on any product and it will appear here with the new dashboard layout.',
    'wishlist.title': 'WISHLIST ({count})',
    'payments.title': 'PAYMENT METHODS',
    'payments.addTitle': 'ADD PAYMENT METHOD',
    'payments.cardNumber': 'Card number',
    'payments.expirationDate': 'Expiration date',
    'payments.securityCode': 'Security code',
    'payments.save': 'Save Payment Method',
    'payments.pay': 'Pay',
    'payments.addNew': 'Add New Payment Method',
    'addresses.title': 'DELIVERY ADDRESSES',
    'addresses.addTitle': 'ADD ADDRESS',
    'addresses.street': 'Street address',
    'addresses.addStreet': 'Add Street',
    'addresses.region': 'Region',
    'addresses.mapTitle': 'Delivery address map',
    'addresses.refineMap': 'Refine location on the map',
    'addresses.note': 'Delivery note',
    'addresses.makeNote': 'Make a note',
    'addresses.nextStep': 'Next Step',
    'addresses.addNew': 'Add New Address',
    'settings.title': 'PROFILE & SETTINGS',
    'settings.name': 'Name',
    'settings.surname': 'Surname',
    'settings.mobile': 'Mobile Number',
    'settings.email': 'E-mail',
    'settings.password': 'Password',
    'settings.firstNamePlaceholder': 'Enter your first name',
    'settings.surnamePlaceholder': 'Enter your surname',
    'settings.mobilePlaceholder': 'Enter your mobile number',
    'settings.emailPlaceholder': 'Enter your e-mail',
    'settings.passwordPlaceholder': 'Enter your new password',
    'settings.saved': 'Your settings were saved successfully.',
    'settings.failed': 'Failed to save settings. Please try again.',
    'footer.about': 'ABOUT US',
    'footer.aboutText': 'Sifrifana is an online gift store offering a curated selection of perfumes, watches, and unique accessories. We bring together gifts people love because great gifts should be easy to find and fun to give.',
    'footer.contactInfo': 'CONTACT INFO',
    'footer.address': '📍 44 Shartava St., Tbilisi',
    'footer.addressSecondary': '📍 30 D. Kvachantiradze St., Tbilisi',
    'footer.phone': 'Phone: +995 558 27 22 14',
    'footer.email': '✉️ info@sifrifana.ge',
    'footer.socialHeading': 'Contact us on social media',
    'footer.socialLinks': 'Social links',
    'footer.myAccount': 'MY ACCOUNT',
    'footer.orderHistory': 'Order History',
    'footer.usefulLink': 'USEFUL LINK',
    'footer.aboutUs': 'About Us',
    'footer.termsConditions': 'Terms And Conditions',
    'footer.privacyPolicy': 'Privacy Policy',
    'footer.rights': '© 2026 Sifrifana, All Rights Reserved',
    'footer.terms': 'Terms',
    'login.welcome': 'Welcome Back',
    'login.subtitle': 'Login to your account',
    'login.failed': 'Login failed',
    'login.remember': 'Remember me',
    'login.forgot': 'Forgot password?',
    'login.loading': 'Logging in...',
    'login.submit': 'Login',
    'login.noAccount': "Don't have an account?",
    'login.createOne': 'Create one',
    'register.title': 'Create Account',
    'register.subtitle': 'Join Sifrifana today',
    'register.passwordMismatch': 'Passwords do not match',
    'register.failed': 'Registration failed',
    'register.fullName': 'Full Name',
    'register.fullNamePlaceholder': 'John Doe',
    'register.confirmPassword': 'Confirm Password',
    'register.agree': 'I agree to the',
    'register.terms': 'Terms & Conditions',
    'register.loading': 'Creating account...',
    'register.submit': 'Create Account',
    'register.haveAccount': 'Already have an account?',
    'register.signIn': 'Sign in',
  },
  ka: {
    'common.home': 'მთავარი',
    'common.product': 'პროდუქტი',
    'common.products': 'პროდუქტი',
    'common.search': 'ძიება...',
    'common.searchProducts': 'პროდუქტების ძიება',
    'common.close': 'დახურვა',
    'common.closeFilters': 'ფილტრების დახურვა',
    'common.noProductsAvailable': 'პროდუქტები არ არის ხელმისაწვდომი',
    'common.noSimilarProducts': 'მსგავსი პროდუქტები ვერ მოიძებნა',
    'common.similarItem': 'მსგავსი პროდუქტი',
    'common.addToCart': 'კალათაში დამატება',
    'common.addToWishlist': 'სურვილების სიაში დამატება',
    'common.removeFromWishlist': 'სურვილების სიიდან წაშლა',
    'common.buyNow': 'იყიდე ახლა',
    'common.subtotal': 'ჯამი',
    'common.shipping': 'მიტანა',
    'common.free': 'უფასო',
    'common.total': 'სულ',
    'common.or': 'ან',
    'common.email': 'ელ. ფოსტა',
    'common.password': 'პაროლი',
    'common.saveChanges': 'ცვლილებების შენახვა',
    'common.saving': 'ინახება...',
    'common.done': 'მზადაა',
    'common.change': 'შეცვლა',
    'common.notSet': 'არ არის მითითებული',
    'common.delete': 'წაშლა',
    'category.watches': 'საათები',
    'category.eyewear': 'სათვალეები',
    'category.eyeglasses': 'მხედველობის სათვალეები',
    'category.perfume': 'სუნამო',
    'category.knives': 'დანები',
    'category.presents': 'საჩუქრები',
    'category.allProducts': 'ყველა პროდუქტი',
    'header.cart': 'კალათა',
    'header.wishlist': 'სურვილები',
    'header.account': 'პროფილი',
    'hero.title': 'საჩუქარი ყველასთვის, მიზეზი შენზეა.',
    'hero.subtitle': 'აღმოაჩინე სიფრიფანა — ათასობით იდეა ერთ სივრცეში.',
    'home.limitedOffers': 'შეზღუდული შეთავაზებები',
    'home.offer.watchEyebrow': 'საათების სპეციალური შეთავაზება',
    'home.offer.watchTitle': '-15%\nყველა\nსაათზე',
    'home.offer.saleEyebrow': 'სეზონური ფასდაკლება',
    'home.offer.saleTitle': 'საახალწლო\nფასდაკლება\n-20%',
    'home.offer.giftTitle': 'უფასო საჩუქარი',
    'home.offer.giftDescription': 'ყოველ შენაძენზე\n100₾-ზე ზემოთ',
    'home.testimonialsTitle': 'რას ამბობენ ჩვენზე',
    'home.testimonialQuote': '"აქციის დროს საათი შევუკვეთე, სწრაფად მოვიდა და ფოტოებზე უკეთესად გამოიყურება. შეფუთვაც ძალიან ხარისხიანი იყო. აუცილებლად კიდევ შევიძენ!"',
    'home.whyTitle': 'რატომ სიფრიფანა?',
    'home.why.serviceTitle': 'გამორჩეული სერვისი',
    'home.why.serviceText': 'მომხმარებელზე ორიენტირებული გუნდი',
    'home.why.deliveryTitle': 'მიტანა ყველა რეგიონში',
    'home.why.deliveryText': 'მიტანის სერვისი მოქმედებს მთელ საქართველოში',
    'home.why.safetyTitle': 'უსაფრთხოება',
    'home.why.safetyText': 'თქვენი გადახდები ჩვენთან ყოველთვის დაცულია',
    'catalog.featured': 'რჩეული',
    'catalog.bestSelling': 'ყველაზე გაყიდვადი',
    'catalog.newArrivals': 'ახალი დამატებული',
    'catalog.priceLowHigh': 'ფასი: დაბლიდან მაღლა',
    'catalog.priceHighLow': 'ფასი: მაღლიდან დაბლა',
    'catalog.saleHighLow': 'ფასდაკლება: მაღლიდან დაბლა',
    'catalog.man': 'კაცი',
    'catalog.woman': 'ქალი',
    'catalog.unisex': 'უნისექსი',
    'catalog.filters': 'ფილტრები',
    'catalog.sortBy': 'დალაგება',
    'catalog.sex': 'სქესი',
    'catalog.brands': 'ბრენდები',
    'catalog.price': 'ფასი',
    'catalog.colors': 'ფერები',
    'catalog.prescription': 'დიოპტრია',
    'catalog.materials': 'მასალები',
    'catalog.giftType': 'საჩუქრის ტიპი',
    'catalog.presentType.knife': 'დანა',
    'catalog.presentType.lighter': 'სანთებელა',
    'catalog.presentType.binoculars': 'ბინოკლი',
    'catalog.presentType.jewelry': 'სამკაული',
    'catalog.clearAll': 'ყველას გასუფთავება',
    'catalog.noProducts': 'პროდუქტები ვერ მოიძებნა',
    'catalog.noProductsHint': 'სცადეთ ფილტრების ან ძიების შეცვლა.',
    'catalog.resetFilters': 'ფილტრების განულება',
    'product.notFound': 'პროდუქტი ვერ მოიძებნა.',
    'product.previousImage': 'წინა ფოტო',
    'product.nextImage': 'შემდეგი ფოტო',
    'product.zoomImage': 'პროდუქტის ფოტოს გადიდება',
    'product.closeZoom': 'გადიდებული ფოტოს დახურვა',
    'product.view': 'ხედი',
    'product.color': 'ფერი',
    'product.prescription': 'დიოპტრია',
    'product.specialCode': '\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D8',
    'product.quantity': 'რაოდენობა',
    'product.inStock': 'მარაგშია',
    'product.outOfStock': 'არ არის მარაგში',
    'product.buyItNow': 'ახლავე ყიდვა',
    'product.installment': 'განვადება',
    'checkout.freeShipping': 'უფასო მიწოდება ყველგან',
    'checkout.paymentOptions': 'გადახდის მეთოდები',
    'checkout.payWithCourier': 'კურიერთან გადახდა',
    'checkout.payByCard': 'ბარათით გადახდა',
    'checkout.contactNotice': 'სიფრიფანას მაღაზია დაგიკავშირდებათ და შეგითანხმებთ შეკვეთის დეტალებს.',
    'checkout.cardRedirectNote': 'ბარათის მონაცემებს უსაფრთხო საბანკო გვერდზე შეიყვანთ.',
    'checkout.phoneNumber': 'ტელეფონის ნომერი',
    'checkout.customerName': 'სახელი და გვარი',
    'checkout.deliveryRegion': 'რეგიონი',
    'checkout.deliveryRegionPlaceholder': 'აირჩიეთ მიწოდების არეალი',
    'checkout.deliveryCity': 'ქალაქი',
    'checkout.deliveryCityPlaceholder': 'ჩაწერეთ მიწოდების ქალაქი',
    'checkout.address': 'მიტანის მისამართი',
    'checkout.addressPlaceholder': 'ზუსტი მიტანის მისამართი',
    'checkout.requiredFields': 'გთხოვთ შეიყვანოთ ტელეფონის ნომერი, სახელი/გვარი, რეგიონი, საჭიროების შემთხვევაში ქალაქი და მიტანის მისამართი.',
    'checkout.invalidPhone': 'ტელეფონის ნომერი უნდა იყოს 9 ციფრი და იწყებოდეს ქართული მობილურის სწორი პრეფიქსით.',
    'checkout.cardRequired': 'გთხოვთ შეიყვანოთ ბარათის ნომერი, ვადა და უსაფრთხოების კოდი.',
    'checkout.failed': 'შეკვეთის გაგზავნა ვერ მოხერხდა. სცადეთ თავიდან.',
    'checkout.checking': 'სტატუსს ვამოწმებთ...',
    'checkout.processing': 'გადახდა მუშავდება...',
    'checkout.order': 'შეკვეთა',
    'checkout.ordering': 'იგზავნება...',
    'checkout.successStrong': 'გმადლობთ, თქვენი შეკვეთა მიღებულია და პროდუქტი დაჯავშნილია.',
    'checkout.successText': 'სიფრიფანას მაღაზია დაგიკავშირდებათ და მოგაწვდით ინფორმაციას გადახდისა და მიწოდების შესახებ.',
    'checkout.workingHours': 'სამუშაო საათები: ყოველდღე, 10:00-19:00',
    'checkout.followFacebook': 'მოიწონეთ ჩვენი ოფიციალური Facebook გვერდი და მიიღეთ ექსკლუზიური სიურპრიზები მთელი წლის განმავლობაში!',
    'checkout.followFacebookPrefix': 'მოიწონეთ ჩვენი ოფიციალური',
    'checkout.followFacebookSuffix': 'გვერდი და მიიღეთ ექსკლუზიური სიურპრიზები მთელი წლის განმავლობაში!',
    'checkout.allProductsTitle': 'ყველა პროდუქტი',
    'product.aboutBrand': 'ბრენდის შესახებ',
    'product.aboutFallback': 'ეს კოლექცია აერთიანებს ხარისხს, კომფორტს და გამორჩეულ დიზაინს ყოველდღიური გამოყენებისთვის.',
    'product.aboutWithBrand': '{description} {brand} შექმნილია ინდივიდუალურობის, კომფორტისა და პრემიუმ ყოველდღიური სტილის დასაბალანსებლად.',
    'product.characteristics': 'მახასიათებლები',
    'product.dimensions': 'ზომები',
    'product.brand': 'ბრენდი',
    'product.style': 'სტილი',
    'product.styleVintage': 'ვინტაჟური',
    'product.styleClassic': 'კლასიკური',
    'product.use': 'გამოყენება',
    'product.useSun': 'მზისთვის',
    'product.useVision': 'მხედველობისთვის',
    'product.useDaily': 'ყოველდღიური',
    'product.material': 'მასალა',
    'product.materialWood': 'ხე',
    'product.materialSteel': 'უჟანგავი ფოლადი',
    'product.frameWidth': 'ჩარჩოს სიგანე',
    'product.frameHeight': 'ჩარჩოს სიმაღლე',
    'product.bridge': 'ხიდი',
    'product.ears': 'ყურები',
    'product.faqPurchaseTitle': 'როგორ შევიძინო პროდუქტი?',
    'product.faqPurchaseText': 'აირჩიეთ ხელმისაწვდომი ვარიანტები და რაოდენობა, დაამატეთ კალათაში და გააგრძელეთ შეკვეთის დასრულება.',
    'product.faqDeliveryTitle': 'როგორ ხდება პროდუქტის მიწოდება?',
    'product.faqDeliveryText': 'შეკვეთები მზადდება 1-2 სამუშაო დღეში და იგზავნება მისამართზე, რომელსაც შეკვეთისას მიუთითებთ.',
    'product.similarItems': 'მსგავსი პროდუქტები',
    'cart.shoppingCart': 'საყიდლების კალათა',
    'cart.empty': 'თქვენი კალათა ცარიელია',
    'cart.orderSummary': 'შეკვეთის შეჯამება',
    'cart.checkout': 'შეკვეთის გაგრძელება',
    'cart.remove': 'წაშლა',
    'cart.myCart': 'ჩემი კალათა',
    'cart.qty': 'რაოდ.',
    'account.myAccount': 'ჩემი ანგარიში',
    'account.orders': 'შეკვეთები',
    'account.myOrders': 'ჩემი შეკვეთები',
    'account.wishlist': 'სურვილების სია',
    'account.paymentMethods': 'გადახდის მეთოდები',
    'account.deliveryAddresses': 'მიტანის მისამართები',
    'account.settings': 'პარამეტრები',
    'account.adminDashboard': 'ადმინის დაფა',
    'account.manageProducts': 'პროდუქტების მართვა',
    'account.users': 'მომხმარებლები',
    'account.signOut': 'გასვლა',
    'account.signIn': 'შესვლა',
    'account.signUp': 'რეგისტრაცია',
    'account.logout': 'გასვლა',
    'account.greeting': 'გამარჯობა, {name}',
    'orders.title': 'ჩემი შეკვეთები ({count})',
    'orders.emptyTitle': 'შეკვეთები ჯერ არ არის',
    'orders.emptyText': 'თქვენი ანგარიში მზადაა. შეკვეთის განთავსების შემდეგ ის აქ გამოჩნდება.',
    'orders.oneItem': '1 პროდუქტი',
    'orders.moreOne': 'და კიდევ 1 პროდუქტი',
    'orders.moreMany': 'და კიდევ {count} პროდუქტი',
    'orders.track': 'შეკვეთის ნახვა',
    'orders.cancel': 'შეკვეთის გაუქმება',
    'orders.trackingSoon': '"{title}" შეკვეთის დეტალები მალე იქნება ხელმისაწვდომი.',
    'orders.status.ordered': 'შეკვეთილია',
    'orders.status.processing': 'მუშავდება',
    'orders.status.shipped': 'გაგზავნილია',
    'orders.status.delivered': 'მიტანილია',
    'orders.status.cancelled': 'გაუქმებულია',
    'wishlist.emptyTitle': 'სურვილების სია ცარიელია',
    'wishlist.emptyText': 'დააჭირეთ გულის აიქონს ნებისმიერ პროდუქტზე და ის აქ გამოჩნდება.',
    'wishlist.title': 'სურვილების სია ({count})',
    'payments.title': 'გადახდის მეთოდები',
    'payments.addTitle': 'გადახდის მეთოდის დამატება',
    'payments.cardNumber': 'ბარათის ნომერი',
    'payments.expirationDate': 'ვადის გასვლის თარიღი',
    'payments.securityCode': 'უსაფრთხოების კოდი',
    'payments.save': 'გადახდის მეთოდის შენახვა',
    'payments.pay': 'გადახდა',
    'payments.addNew': 'ახალი გადახდის მეთოდი',
    'addresses.title': 'მიტანის მისამართები',
    'addresses.addTitle': 'მისამართის დამატება',
    'addresses.street': 'ქუჩის მისამართი',
    'addresses.addStreet': 'ქუჩის დამატება',
    'addresses.region': 'რეგიონი',
    'addresses.mapTitle': 'მიტანის მისამართის რუკა',
    'addresses.refineMap': 'დააზუსტეთ მდებარეობა რუკაზე',
    'addresses.note': 'მიტანის შენიშვნა',
    'addresses.makeNote': 'შენიშვნის დამატება',
    'addresses.nextStep': 'შემდეგი ნაბიჯი',
    'addresses.addNew': 'ახალი მისამართი',
    'settings.title': 'პროფილი და პარამეტრები',
    'settings.name': 'სახელი',
    'settings.surname': 'გვარი',
    'settings.mobile': 'მობილურის ნომერი',
    'settings.email': 'ელ. ფოსტა',
    'settings.password': 'პაროლი',
    'settings.firstNamePlaceholder': 'შეიყვანეთ სახელი',
    'settings.surnamePlaceholder': 'შეიყვანეთ გვარი',
    'settings.mobilePlaceholder': 'შეიყვანეთ მობილურის ნომერი',
    'settings.emailPlaceholder': 'შეიყვანეთ ელ. ფოსტა',
    'settings.passwordPlaceholder': 'შეიყვანეთ ახალი პაროლი',
    'settings.saved': 'თქვენი პარამეტრები წარმატებით შეინახა.',
    'settings.failed': 'პარამეტრების შენახვა ვერ მოხერხდა. სცადეთ ხელახლა.',
    'footer.about': 'ჩვენ შესახებ',
    'footer.aboutText': 'სიფრიფანა — 2019 წლიდან ვქმნით სივრცეს, სადაც მრავალფეროვანი არჩევანი და სასიამოვნო მომსახურება ერთიანდება.',
    'footer.contactInfo': 'საკონტაქტო ინფორმაცია',
    'footer.address': '📍 შარტავას ქ. 44, თბილისი',
    'footer.addressSecondary': '📍 დ. კვაჭანტირაძის ქ. 30, თბილისი',
    'footer.phone': 'ტელეფონი: +995 558 27 22 14',
    'footer.email': '✉️ info@sifrifana.ge',
    'footer.socialHeading': 'დაგვიკავშირდით სოციალურ ქსელებში',
    'footer.socialLinks': 'სოციალური ბმულები',
    'footer.myAccount': 'ჩემი ანგარიში',
    'footer.orderHistory': 'შეკვეთების ისტორია',
    'footer.usefulLink': 'სასარგებლო ბმულები',
    'footer.aboutUs': 'ჩვენ შესახებ',
    'footer.termsConditions': 'წესები და პირობები',
    'footer.privacyPolicy': 'კონფიდენციალურობა',
    'footer.rights': '© 2026 სიფრიფანა, ყველა უფლება დაცულია',
    'footer.terms': 'წესები',
    'login.welcome': 'კეთილი იყოს თქვენი დაბრუნება',
    'login.subtitle': 'შედით თქვენს ანგარიშში',
    'login.failed': 'შესვლა ვერ მოხერხდა',
    'login.remember': 'დამიმახსოვრე',
    'login.forgot': 'დაგავიწყდათ პაროლი?',
    'login.loading': 'შესვლა...',
    'login.submit': 'შესვლა',
    'login.noAccount': 'არ გაქვთ ანგარიში?',
    'login.createOne': 'შექმენით',
    'register.title': 'ანგარიშის შექმნა',
    'register.subtitle': 'შემოუერთდით სიფრიფანას დღეს',
    'register.passwordMismatch': 'პაროლები არ ემთხვევა',
    'register.failed': 'რეგისტრაცია ვერ მოხერხდა',
    'register.fullName': 'სრული სახელი',
    'register.fullNamePlaceholder': 'სახელი გვარი',
    'register.confirmPassword': 'გაიმეორეთ პაროლი',
    'register.agree': 'ვეთანხმები',
    'register.terms': 'წესებსა და პირობებს',
    'register.loading': 'ანგარიში იქმნება...',
    'register.submit': 'ანგარიშის შექმნა',
    'register.haveAccount': 'უკვე გაქვთ ანგარიში?',
    'register.signIn': 'შესვლა',
    'checkout.courierServiceFee': '+5 GEL / +5 ლარი საკურიერო მომსახურება',
    'checkout.boxTitle': 'აირჩიეთ სასაჩუქრე ყუთი',
    'checkout.boxSubtitle': 'შეფუთვა',
    'checkout.boxBasic': 'უფასო basic ყუთი',
    'checkout.boxGood': 'Good ყუთი',
    'checkout.boxBrand': 'Brand Sifrifana ყუთი',
    'checkout.boxSummary': 'ყუთი',
    'checkout.included': 'შედის ფასში',
    'checkout.termsAgree': 'ვეთანხმები',
    'checkout.termsLink': 'წესებსა და პირობებს',
    'checkout.termsRequired': 'გთხოვთ დაადასტუროთ, რომ ეთანხმებით წესებსა და პირობებს.',
    'checkout.personalId': 'პირადი ნომერი',
    'checkout.personalIdPlaceholder': 'შეიყვანეთ პირადი ნომერი',
    'checkout.knifeVerificationTitle': 'დანის შეძენის დადასტურება',
    'checkout.knifeGuidelinesAgreement': 'ვადასტურებ, რომ ვარ 21 წლის ან უფროსი და ვეთანხმები დანის შეძენასთან დაკავშირებულ საქართველოს ყველა წესს.',
    'checkout.knifeVerificationRequired': 'დანის შეკვეთისთვის საჭიროა პირადი ნომერი და 21+ წესების დადასტურება.',
  },
};

const formatTranslation = (template, params = {}) =>
  Object.entries(params).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
    template
  );

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_LANGUAGE;

    if (window.localStorage.getItem(LANGUAGE_DEFAULT_VERSION_KEY) !== LANGUAGE_DEFAULT_VERSION) {
      return DEFAULT_LANGUAGE;
    }

    const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return ['en', 'ka'].includes(savedLanguage) ? savedLanguage : DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    window.localStorage.setItem(LANGUAGE_DEFAULT_VERSION_KEY, LANGUAGE_DEFAULT_VERSION);
    document.documentElement.lang = language === 'ka' ? 'ka' : 'en';
  }, [language]);

  const value = useMemo(() => {
    const t = (key, params) => {
      const template = translations[language]?.[key] || translations.en[key] || key;

      return formatTranslation(template, params);
    };

    return {
      language,
      isGeorgian: language === 'ka',
      setLanguage,
      toggleLanguage: () => setLanguage((current) => (current === 'en' ? 'ka' : 'en')),
      t,
    };
  }, [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }

  return context;
};

export default LanguageContext;
